import type { ArticleView } from './../type/article';
import type { MetaSocial } from './../type/social.d';

type buildMetaOptions = {
  global?: MetaSocial;
  section?: MetaSocial;
  article?: ArticleView;
  description?: string;
  image?: string;
  title?: string;
  url?: string;
};

export const buildMeta = ({
  global,
  section,
  article,
  description,
  image,
  title,
  url,
}: buildMetaOptions): Record<string, string | undefined>[] => {
  description = description || article?.social?.description || section?.description || global?.description;
  image = image || article?.social?.image?.url || section?.image?.url || global?.image?.url;
  url = url ? `https://insiderx.com${url}` : article?.link.url;

  // clean trailing slash to prevent 301s
  if (url && url[url.length - 1] === '/') {
    url = url.slice(0, url.length - 1);
  }

  title =
    title ||
    article?.social?.pageTitle ||
    section?.pageTitle ||
    section?.siteTitle ||
    global?.pageTitle ||
    global?.siteTitle;
  return [
    { name: 'description', content: description },
    { name: 'twitter:domain', content: section?.twitter?.domain || global?.twitter?.domain },
    {
      name: 'twitter:card',
      content: article?.social?.twitterCardStyle || section?.twitter?.cardStyle || global?.twitter?.cardStyle,
    },
    { name: 'twitter:site', content: section?.twitter?.site || global?.twitter?.site },
    { name: 'twitter:creator', content: section?.twitter?.creator || global?.twitter?.creator },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: image },
    { name: 'twitter:url', content: url },
    {
      name: 'twitter:label1',
      content: article?.publishDate && (section?.twitter?.publishedLabel || global?.twitter?.publishedLabel),
    },
    { name: 'twitter:data1', content: article?.publishDate },
    {
      name: 'twitter:label2',
      content: article?.readTime && (section?.twitter?.readingTimeLabel || global?.twitter?.readingTimeLabel),
    },
    { name: 'twitter:data2', content: article?.readTime },
    { property: 'og:site_name', content: section?.facebook?.site || global?.facebook?.site },
    {
      property: 'og:type',
      content: article?.social?.facebookType || section?.facebook?.type || global?.facebook?.type,
    },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:image', content: image },
    { property: 'og:url', content: url },
  ].filter((entry) => entry.content);
};
